/* eslint-disable camelcase */
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsGravatar from '@netsapiens/netsapiens-js/dist/gravatar';
import nsModels from '@netsapiens/netsapiens-js/dist/models';
import { getInitials } from '../../../utils';
import bugsnagClient from '../../../bugsnag';

export default ({
  displayName,
  domain,
  sub,
  user,
  user_email = '',
  user_scope,
  userId,
}) => new Promise((resolve) => {
  bugsnagClient.user = {
    domain,
    id: sub,
    user,
    userId,
    scope: user_scope,
  };

  if (user_scope !== 'guest') {
    const userFields = [
      'dial_plan',
      'domain',
      'first_name',
      'email',
      'last_name',
      'language',
      'scope',
      'subscriber_login',
      'user',
      'initials',
    ];

    nsApi.get({
      user,
      domain,
      object: 'subscriber',
      action: 'read',
      fields: userFields.join(','),
      format: 'json',
      includeDomain: 'yes',
    }).then((res) => {
      const resUser = res[0];

      if (resUser.email !== '') {
        resUser.email = (resUser.email || []).trim().toLowerCase().split(';');
      }

      let dn = displayName;
      if (!dn) {
        dn = `${resUser.first_name} ${resUser.last_name}`;
      }

      const User = new nsModels.user.User({
        dialPlan: resUser.dial_plan,
        displayName: dn,
        domain,
        email: resUser.email,
        firstName: resUser.first_name,
        initials: getInitials(dn),
        language: resUser.language,
        lastName: resUser.last_name,
        scope: user_scope,
        subscriberLogin: resUser.subscriber_login,
        uid: sub,
        user: resUser,
        userId,
      });

      if (User.email) {
        nsGravatar.getGravitar(User.email, 250).then((r) => {
          if (r && r.length > 500) {
            User.gravatar = r;
          }
          resolve(User);
        });
      } else {
        resolve(User);
      }
    });
  } else {
    const User = new nsModels.user.User({
      displayName: displayName || user_scope,
      domain,
      initials: getInitials(displayName || user_scope),
      isSelf: true,
      scope: user_scope,
      userId,
    });

    if (user_email) {
      User.email = [user_email];
    }

    if (User.email) {
      nsGravatar.getGravitar(User.email, 250).then((res) => {
        if (res && res.length > 500) {
          User.gravatar = res;
        }
        resolve(User);
      });
    } else {
      resolve(User);
    }
  }
});
